import {
  ConversationTypeEnum,
  ReplyOption
} from "@coxauto-ui/cxm/communications/interfaces";
import { useContext } from "react";
import { ConversationDetailsContext } from "../../context";
import { StationeryOptions } from "@coxauto-ui/cxm/communications/api";
import { useCxmFlags } from "@coxauto-ui/core/third-party/launch-darkly";
import { useMediaEntitlement } from "../hooks/useMediaEntitlement";
import EmailReply from "./email-reply";
import TextReply from "./text-reply";
import PhoneReply from "./phone-reply";

interface ReplyTypeSwitchProps {
  stationeryOptions: StationeryOptions;
  selectedReplyOption: ReplyOption | null;
  messageFailedToSend: boolean;
  messageSentResponseFailedMsg: string;
  isTextAndNoPhoneNumber: boolean;
  isTextWithRepairOrderOnly: boolean;
  onMessageSendFailed: () => void;
  onMessageSendFailedSetMsg: (msg: string) => void;
}

export function ReplyTypeSwitch({
  stationeryOptions,
  selectedReplyOption,
  messageFailedToSend,
  messageSentResponseFailedMsg,
  isTextAndNoPhoneNumber,
  isTextWithRepairOrderOnly,
  onMessageSendFailed,
  onMessageSendFailedSetMsg
}: ReplyTypeSwitchProps) {
  const { currentConversationType } = useContext(ConversationDetailsContext);
  const { "nx.cxm.inbox-show-media-library": showMediaLibraryFlag } =
    useCxmFlags();
  const { isMediaEntitled } = useMediaEntitlement(showMediaLibraryFlag);

  switch (currentConversationType) {
    case ConversationTypeEnum.EMAIL:
      return (
        <EmailReply
          isMediaEntitled={isMediaEntitled}
          messageFailedToSend={messageFailedToSend}
          messageSentResponseFailedMsg={messageSentResponseFailedMsg}
          selectedReplyOption={selectedReplyOption}
          stationeryOptions={stationeryOptions}
          onMessageSendFailed={onMessageSendFailed}
          onMessageSendFailedSetMsg={onMessageSendFailedSetMsg}
        />
      );

    case ConversationTypeEnum.TEXT:
      return (
        <TextReply
          isMediaEntitled={isMediaEntitled}
          isTextAndNoPhoneNumber={isTextAndNoPhoneNumber}
          isTextWithRepairOrderOnly={isTextWithRepairOrderOnly}
          messageFailedToSend={messageFailedToSend}
          messageSentResponseFailedMsg={messageSentResponseFailedMsg}
          selectedReplyOption={selectedReplyOption}
          stationeryOptions={stationeryOptions}
          onMessageSendFailed={onMessageSendFailed}
          onMessageSendFailedSetMsg={onMessageSendFailedSetMsg}
        />
      );

    case ConversationTypeEnum.PHONE:
      return (
        <PhoneReply
          messageFailedToSend={messageFailedToSend}
          messageSentResponseFailedMsg={messageSentResponseFailedMsg}
          selectedReplyOption={selectedReplyOption}
          stationeryOptions={stationeryOptions}
          onMessageSendFailed={onMessageSendFailed}
          onMessageSendFailedSetMsg={onMessageSendFailedSetMsg}
        />
      );

    default:
      return null;
  }
}

export default ReplyTypeSwitch;
